import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Home from './home';
import Adduser from './adduser';
import Createadmin from './createadmin';
import Groups from './groups';
import Editprofile from './editprofile';
import OneToOneAdd from './OneToOneAdd';
import OneToOneReview from './OneToOneReview';
import AddMeetings from './AddMeetings';
import ViewMeetings from './ViewMeetings';
import FeesAdd from './FeeAdd';
import FeesReview from './FeesReview';
import ChangePass from './changepass';
import Layout from './Layout';
import AddReferral from './AddReferral';
import ReferralGiven from './ReferralGiven';
import ReferralReceived from './ReferralReceived';
import ThankYouAdd from './ThankYouAdd';
import ThankYouReview from './ThankYouReview';
import ViewProfile from './ViewProfile';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Route without Sidebar */}
        <Route path="/" element={<Login />} />

        {/* Routes with Sidebar */}
        <Route path="/" element={<Layout />}>
          <Route path="home" element={<Home />} />
          <Route path="adduser" element={<Adduser />} />
          <Route path="createadmin" element={<Createadmin />} />
          <Route path="groups" element={<Groups />} />
          <Route path="editprofile" element={<Editprofile />} />
          <Route path="OneToOneAdd" element={<OneToOneAdd />} />
          <Route path="OneToOneReview" element={<OneToOneReview />} />
          <Route path="AddMeetings" element={<AddMeetings />} />
          <Route path="ViewMeetings" element={<ViewMeetings />} />
          <Route path="FeesAdd" element={<FeesAdd />} />
          <Route path="FeesReview" element={<FeesReview />} />
          <Route path="ChangePass" element={<ChangePass />} />
          <Route path="AddReferral" element={<AddReferral />} />
          <Route path="ReferralGiven" element={<ReferralGiven />} />
          <Route path="ReferralReceived" element={<ReferralReceived />} />
          <Route path="ThankYouAdd" element={<ThankYouAdd />} />
          <Route path="ThankYouReview" element={<ThankYouReview />} />
          <Route path="ViewProfile" element={<ViewProfile/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
